export const normalizeMenuPath = (path = "/") => path.toLowerCase().replace(/\/+$/, "") || "/";

export function getSelectedMenuPath(pathname, routes, matchesRoute, navigationState) {
  if (normalizeMenuPath(pathname) === "/orders/view" && navigationState?.fromDeliveredOrders) {
    return "/delivered";
  }
  const page = routes.find((route) => matchesRoute(route.path, pathname));
  const parent = page?.breadcrumbs?.find((crumb) => crumb.to)?.to;
  return normalizeMenuPath(parent || pathname);
}

export function isMenuBranchActive(items = [], selectedPath) {
  return items.some((item) =>
    item.active || item.hasActiveChild ||
    (item.to && normalizeMenuPath(item.to) === normalizeMenuPath(selectedPath)) ||
    isMenuBranchActive(item.items || item.content || [], selectedPath)
  );
}